import { createSafeContainer } from '../../../../../../lib/utils/safe-container'

import { useProductDetails } from './useProductDetails'

export const ProductDetailsContainer = createSafeContainer(useProductDetails)
